import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';


import { getTotal, getCartProducts } from '../../../reducers'
import { addToCart, addToWishlist, addToCompare } from '../../../actions'
import { getVisibleproducts } from '../../../services';
import ProductListItem from "./product-lists-item";
import Loading from '../../layouts/loading';
import ItemNotFound from '../../layouts/item-not-found';

class ProductListing extends Component {

    constructor(props) {
        super(props)
        this.state = { limit: 100, hasMoreItems: true };
        this.selectProduct = this.selectProduct.bind(this)
    }

    selectProduct() { };
    componentWillMount() {
        this.fetchMoreItems();
    }

    fetchMoreItems = () => {
        if (this.state.limit >= this.props.products.length) {
            this.setState({ hasMoreItems: false });
            return;
        }
        // a fake async api call
        setTimeout(() => {
            this.setState({
                limit: this.state.limit + 5
            });
        }, 3000);


    }

    render() {
        const { products, selectProduct, addToCart, symbol, addToWishlist, addToCompare, loading } = this.props;
        return (
            <div>
                <div className="product-wrapper-grid">
                    <div className="container-fluid">
                        {!loading ?
                            products.length > 0 ?
                                <div className="row">
                                    {products.slice(0, this.state.limit).map((product, index) =>
                                        <div className={`${this.props.colSize === 3 ? 'col-xl-3 col-sm-6 col-md-6 col-grid-box' : 'col-lg-' + this.props.colSize}`} key={index}>
                                            <ProductListItem selectProduct={() => selectProduct(product)} product={product} symbol={symbol}
                                                onAddToCompareClicked={() => addToCompare(product)}
                                                onAddToWishlistClicked={() => addToWishlist(product)}
                                                onAddToCartClicked={addToCart} key={index} />
                                        </div>)
                                    }  
                                </div>
                           
                                // </InfiniteScroll>
                                :
                                <ItemNotFound />
                            :
                            <div>
                             <Loading />
                            <h6 className='mt-5 text-center'>درحال دریافت اطلاعات</h6>    
                            </div>
                            
                        }
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return ({
        // products: getVisibleproducts(state.data, state.filters),
        // symbol: state.data.symbol,
    })
}
// export default ProductListing;

export default connect(
    mapStateToProps,
    { addToCart, addToWishlist, addToCompare }
)(ProductListing)